import React from "react"
import RatingStars from "buoy-stars"
import styled, { css } from "styled-components"
import Check from "../../completion/images/Check"
import Source from '../../interview/Source'
import { captureException } from '../../common/error'
import { colors, fontSize, fontWeight } from "buoy-theme"
import { Button, Paragraph, FormInput } from "buoy-core"
import { CardSection } from "../../completion/components/Card"

const SubmitDisabledArea = styled.div`
  ${props => props.submitted && css`
    opacity: 0.5;
    pointer-events: none;
  `}
`

const RatingContainer = styled.div`
  margin-top: 12px;
`

const ThanksWrapper = styled.div`
  ${fontSize("bodyMain")}
  color: ${colors.primary};
  margin-top: 16px;
`

const ThanksCheck = styled(Check)`
  display: inline;
  margin-left: 2px;
`

const Response = styled(FormInput)`
  margin: 12px 0;
`

const SectionHeader = styled(Paragraph)`
  font-weight: ${fontWeight.regular};
  display: block;
`

const Thanks = () => (
  <ThanksWrapper>
    Thanks for your feedback! <ThanksCheck color="primary" />
  </ThanksWrapper>
)

const Explanation = ({ response, active, onChangeResponse, onSubmit }) => (
  <div>
    <Response
      placeholder={active <= 4 ? "How could we improve your experience?" : "What is the main reason for your score?"}
      value={response}
      onChange={onChangeResponse}
    />
    <Button onClick={onSubmit}>Submit</Button>
  </div>
)

const UserSatisfaction = ({
  hover,
  active,
  response,
  submitted,
  onChangeResponse,
  onSubmit,
  setActive,
  setHover,
}) => (
  <CardSection noBorder padding="0 0 32px">
    <SubmitDisabledArea submitted={submitted} >
      <SectionHeader>
        How would you rate your experience today?
      </SectionHeader>
      <RatingContainer>
        <RatingStars
          hover={hover}
          active={active}
          setActive={setActive}
          setHover={setHover}
        />
        {active && (
          <Explanation
            response={response}
            active={active}
            onChangeResponse={onChangeResponse}
            onSubmit={onSubmit}
          />
        )}
      </RatingContainer>
    </SubmitDisabledArea>
    {submitted && <Thanks />}
  </CardSection>
)

class UserSatisfactionContainer extends React.Component {
  constructor() {
    super()
    this.state = {
      hover: null,
      active: null,
      response: "",
      submitted: false
    }
  }

  setActive = index => {
    this.setState({ active: index })
  }

  setHover = index => {
    this.setState({ hover: index })
  }

  handleResponseChange = e => {
    this.setState({ response: e.target.value })
  }

  handleSubmit = () => {
    this.setState({submitted: true})
    Source.recordUserSatisfaction(this.state.active, this.state.response)
      .catch(captureException)
  }

  render() {
    return (
      <UserSatisfaction
        {...this.props}
        {...this.state}
        onChangeResponse={this.handleResponseChange}
        onSubmit={this.handleSubmit}
        setActive={this.setActive}
        setHover={this.setHover}
      />
    )
  }
}

export { UserSatisfactionContainer as default, UserSatisfaction }



// WEBPACK FOOTER //
// ./assets/feedback/components/UserSatisfaction.js